export class SetTwoFactorAuthModel {
  Email: string;
  IsEnabled: boolean;

  constructor(email: string, isEnabled: boolean) {
    this.Email = email;
    this.IsEnabled = isEnabled;
  }
}
